$(document).ready(function (e) {
    $(document).on('click', '.edit-no-series', function (e) {
        e.preventDefault();
        let loaded = parseInt($('#auto-series-model').attr('data-loaded'));
        $('#auto-series-model').modal('toggle');
        if (!loaded) {
            $.ajax({
                type: 'GET',
                url: '/auto-no-series',
                success: function (res) {
                    $('#auto-series-body').html(res);
                    prepareDateRanges($('#auto-series-body').find('table > tbody'));
                }
            });
        }
    });

    $(document).on('click', '.add-no-series', function (e) {
        $.ajax({
            type: 'GET',
            url: '/auto-no-series/new',
            success: function (res) {
                if (!$('#auto-series-body').find('.no-series-row[data-id=""]').length) {
                    $('#auto-series-body').find('table > tbody').append(res);
                    prepareDateRanges($('#auto-series-body').find('table > tbody > tr:last-child'));
                } else {
                    toastr.info(translation.number_series_saving_is_required);
                }
            }
        });
    });

    function prepareDateRanges($container) {
        let date_format = $('meta[name="date-format"]').attr('content');

        $container.find('.series-from-date, .series-end-date').flatpickr({
            weekNumbers: true,
            dateFormat: date_format,
            allowInput: true,
            onChange: function (selectedDates, dateStr, instance) {
                $(instance.element).attr('value', dateStr);
            }, onReady: function (dateObj, dateStr, instance) {
                var $cal = $(instance.calendarContainer);
                if ($cal.find('.flatpickr-clear').length < 1) {
                    $cal.append('<div class="flatpickr-clear">Clear</div>');
                    $cal.find('.flatpickr-clear').on('click', function () {
                        instance.clear();
                        instance.close();
                        $(instance.element).trigger('keyup');
                    });
                }
            }
        });
    }

    $(document).on('change', '.series-table', function (e) {
        let id = $(this).val();

        if (id.length) {
            $.ajax({
                type: "GET",
                url: '/tablebuilder/table/fields/dropdown',
                data: {
                    id,
                    type: 'date',
                    timestamps: 1
                },
                success: (res) => {
                    $(this).parents('tr').find('.series-date-field').html(res);
                }
            });

            $.ajax({
                type: "GET",
                url: '/tablebuilder/table/fields/dropdown',
                data: {
                    id,
                    type: 'autonumber'
                },
                success: (res) => {
                    $(this).parents('tr').find('.series-auto-field').html(res);
                }
            });
        }
    });

    $(document).on('click', '#save-auto-series', function (e) {
        let $no_series = $('.no-series-row'),
            payload = {};

        $('.form-control').removeClass('is-invalid');
        $('.invalid-feedback').empty();

        $no_series.each(function (index, $no_series) {
            let id = $($no_series).attr('data-id'),
                table = $($no_series).find('.series-table').val(),
                auto_number_field = $($no_series).find('.series-auto-field').val(),
                customer = $($no_series).find('.series-contact').val(),
                description = $($no_series).find('.series-description').val(),
                prefix = $($no_series).find('.series-prefix').val(),
                order = $($no_series).find('.series-prefix-order').val(),
                starting_no = $($no_series).find('.series-starting-no').val(),
                ending_no = $($no_series).find('.series-ending-no').val(),
                from_date = $($no_series).find('.series-from-date').val(),
                to_date = $($no_series).find('.series-end-date').val(),
                date_field = $($no_series).find('.series-date-field').val();

            if (id.length) {
                $.ajax({
                    type: "POST",
                    url: '/auto-no-series/update',
                    data: {
                        id,
                        index,
                        table,
                        auto_number_field,
                        customer,
                        description,
                        prefix,
                        order,
                        starting_no,
                        ending_no,
                        from_date,
                        to_date,
                        date_field
                    },
                    success: (res) => {
                        toastr.success(`${translation.series} # ${index + 1} ${translation.updated}`);
                    },
                    error: (res) => {
                        let errors = res.responseJSON.errors;
                        toastr.error(`${translation.series} # ${index + 1} ${translation.update_failed}`);

                        for (let key in errors) {
                            if (errors.hasOwnProperty(key)) {
                                $($no_series).find(`.form-control[data-name="${key}"]`).addClass('is-invalid');
                                $($no_series).find(`.form-control[data-name="${key}"]`).siblings('.invalid-feedback').text(errors[key]);
                            }
                        }
                    }
                })
            } else {
                $.ajax({
                    type: "POST",
                    url: '/auto-no-series',
                    data: {
                        index,
                        table,
                        auto_number_field,
                        customer,
                        description,
                        prefix,
                        order,
                        starting_no,
                        ending_no,
                        from_date,
                        to_date,
                        date_field
                    },
                    success: (res) => {
                        if (res.success) {
                            toastr.success(`${translation.series} # ${index + 1} ${translation.updated}`);
                            $($no_series).attr('data-id', res.id);
                            $($no_series).find('.delete-auto-series').removeClass('d-none');
                        }
                    },
                    error: (res) => {
                        let errors = res.responseJSON.errors;
                        toastr.error(`${translation.series} # ${index + 1} ${translation.update_failed}`);
                        for (let key in errors) {
                            if (errors.hasOwnProperty(key)) {
                                $($no_series).find(`.form-control[data-name="${key}"]`).addClass('is-invalid');
                                $($no_series).find(`.form-control[data-name="${key}"]`).siblings('.invalid-feedback').text(errors[key]);
                            }
                        }
                    }
                })
            }
        });
    });

    $(document).on('click', '.delete-auto-series', function (e) {
        let id = $(this).parents('.no-series-row').attr('data-id');

        if (confirm(translation.confirm_number_series_delete)) {
            if (id.length) {
                $.ajax({
                    type: "DELETE",
                    url: '/auto-no-series',
                    data: {
                        id,
                    },
                    success: (res) => {
                        if (res) {
                            $(this).parents('.no-series-row').remove();
                        }
                    }
                })
            } else {
                $(this).parents('.no-series-row').remove();
            }
        }
    });
});